import { Stack, Typography } from '@mui/material';
import { RadioIconButtons } from 'Components/RadioIconButtons';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { HELPFULNESS } from 'Enum/Feedback';
import { useDictionary } from 'Hooks';
import { NotHelpful, PartiallyHelpful, VeryHelpful } from 'Images';

interface IHelpfulness {
  helpfulnessValue: HELPFULNESS | '';
  setHelpfulnessValue: (value: HELPFULNESS | '') => void;
}

export const Helpfulness = ({
  helpfulnessValue,
  setHelpfulnessValue,
}: IHelpfulness) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Feedback);

  return (
    <Stack
      sx={{
        gap: '24px',
      }}
    >
      <Typography variant='body2' id='helpfulness-label'>
        {dictionary.wasItHelpful}
      </Typography>
      <RadioIconButtons
        options={Object.values(HELPFULNESS)}
        setValue={(value) => setHelpfulnessValue(value as HELPFULNESS | '')}
        value={helpfulnessValue}
        labelledby='helpfulness-label'
        iconSrcArray={[VeryHelpful, PartiallyHelpful, NotHelpful]}
      />
    </Stack>
  );
};
